<template>
  <Layout
    @componentKey="gotRefresh"
    @currentPage="currentPage"
    :amount="this.DHRIpc.length > 0 ? 5 : 4"
    :amountToShow="1"
    :hasPagination="true"
    :hasBackButton="true"
    :hasBreadcrumbs="false"
  >
    <div class="content-dhr">
      <MainTitle :title="pageTitle" />
      <GeneralDHRInfo :data="DHRGenalInfo" />

      <div v-if="this.pagina == 1" class="page">
        <div class="page-content">
          <ListDHRDetailProduction :data="DHRFlowSteps" />
        </div>
        <div class="sidebar">
          <DHRApprovalView :data="DHRGenalInfo" />
          <DHRQRView :data="DHRGenalInfo" />
        </div>
      </div>

      <div v-if="this.pagina == 2" class="page">
        <div class="sidebar sidebar-left">
          <DHRImageView :data="DHRAssembly" />
        </div>
        <div class="page-content">
          <ListDHRDetailSubparts :data="DHRAssemblySubparts" />
        </div>
      </div>
      <div v-if="this.pagina == 3" class="page">
        <div class="sidebar-sm">
          <DHRProductionStepMenu
            :data="DHRFlowSteps"
            @selectedStep="showStepDetails"
          />
        </div>
        <div class="page-content">
          <ListDHRCustomValues :data="selectedStepData" />
        </div>
      </div>

      <div v-if="this.pagina == 4" class="page">
        <div class="page-content content-inspect">
          <ListDHRInspectionValues
            :DHRID="DHRGenalInfo.deviceID"
            :totalSamples="1"
            :data="DHRInspection"
            :flowID="DHRGenalInfo.flowID"
            :completed="0"
            :measurment="measurement"
            :checkValues="checkValues"
          />
        </div>
        <div class="sidebar sidebar-inspect">
          <DHRImageView :data="DHRAssembly" />
        </div>
        <!-- <div class="sidebar-sm">
          <DHRSampleMenu :totalSamples="totalInspectionSamples" :data="DHRInspectionValues" @selectedInspection="showInspectionDetails"/>
        </div>
        <div class="page-content">
          <ListDHRInspectionValues :data="selectedInspectionData"/>
        </div>-->
      </div>

      <div v-if="this.pagina == 5" class="page">
        <!-- <div class="sidebar-sm">
          <DHRSampleMenu
            :totalSamples="totalIpcSamples"
            :data="DHRIpc"
            @selectedIPC="showIpcDetails"
          />
        </div>
        <div class="page-content">
          <ListDHRIpcValues :data="selectedIPCData" />
        </div>-->
        <div class="page-content content-inspect">
          <ListDHRIpcValues
            :DHRID="DHRGenalInfo.DHRID"
            :totalSamples="totalInspectionSamples"
            :data="DHRIpc"
            :flowID="this.DHRFlowSteps[0].flowID"
            :completed="DHRGenalInfo.finished"
            :measurment="measurementIPC"
            :checkValues="checkValuesIPC"
          />
        </div>
        <div class="sidebar sidebar-inspect">
          <DHRImageView :data="DHRAssembly" />
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/layouts/Dashboard";
import MainTitle from "@/components/base/MainTitle";
import GeneralDHRInfo from "@/components/GeneralDHRInfo";
import ListDHRDetailProduction from "@/components/ListDHRDetailProduction";
import ListDHRDetailSubparts from "@/components/ListDHRDetailSubparts";
import DHRApprovalView from "@/components/DHRApprovalView";
import DHRQRView from "@/components/DHRQRView";
import DHRImageView from "@/components/DHRImageView";
import DHRProductionStepMenu from "@/components/DHRProductionStepMenu";
import ListDHRCustomValues from "@/components/ListDHRCustomValues";
import DHRSampleMenu from "@/components/DHRSampleMenu";
import ListDHRInspectionValues from "@/components/ListDHRInspectionValues";
import ListDHRIpcValues from "@/components/ListDHRIpcValues";

export default {
  name: "production-inProgress",
  components: {
    Layout,
    MainTitle,
    GeneralDHRInfo,
    ListDHRDetailProduction,
    ListDHRDetailSubparts,
    DHRApprovalView,
    DHRQRView,
    DHRImageView,
    DHRProductionStepMenu,
    ListDHRCustomValues,
    DHRSampleMenu,
    ListDHRInspectionValues,
    ListDHRIpcValues,
  },
  props: {
    compKey: Number,
  },
  data() {
    return {
      DHRGenalInfo: {},
      DHRFlowSteps: [],
      DHRAssembly: {},
      DHRAssemblySubparts: [],
      DHRStepValues: [],
      DHRStepCompletion: [],
      DHRStepDeviation: [],
      DHRInspection: [],
      DHRInspectionValues: [],
      DHRIpc: [],
      DHRIpcValues: [],
      measurement: [],
      measurementIPC: [],

      DHRqr: String,
      DHR: String,
      pagina: 1,
      pageTitle: "General info",
      DHRid: String,
      DHRLot: String,
      totalInspectionSamples: 1,
      totalIpcSamples: 2,
      selectedStepData: {},
      selectedInspectionData: {},
      selectedIPCData: {},

      checkValues: [],
      checkValuesIPC: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      this.deviceID = that.$router.currentRoute.params.deviceid;
      this.deviceRef = that.$router.currentRoute.params.deviceref;
      this.flowID = that.$router.currentRoute.params.flowid;
      this.pageTitle = "General info (Device: " + this.deviceRef + ")";

      this.$http
        .get(
          this.$endpoint +
            "production/dhr/detail/master/" +
            this.deviceID +
            "/" +
            this.flowID
        )
        .then((response) => {
          this.DHRGenalInfo = response.data.detail;
          this.DHRAssembly = response.data.parts[0];
          let steps = response.data.steps.sort((a, b) =>
            a.order > b.order ? 1 : -1
          );
          this.DHRFlowSteps = steps;
          this.DHRStepValues = response.data.customStep;
          this.DHRStepDeviation = response.data.deviations;
          this.DHRAssemblySubparts = response.data.subparts;
          this.DHRStepCompletion = response.data.stepValues;
          this.DHRInspection = [
            { post: true, values: response.data.inspection },
          ];
          this.DHRIpc = [{ post: true, values: response.data.IPCtype }];
          this.DHRInspectionValues = response.data.inspectionValues;
          // this.DHRIpc = response.data.IPCtype;
          this.DHRIpcValues = response.data.IPCValue;

          this.checkValues = [];
          for (let s = 0; s < this.totalInspectionSamples; s++) {
            let sample = this.DHRInspection[s];

            let defChecks = [];
            let custChecks = [];

            for (let v = 0; v < sample.values.length; v++) {
              if (sample.values[v].letter == "bool") {
                defChecks.push(sample.values[v]);
              } else {
                custChecks.push(sample.values[v]);
              }
            }

            defChecks.sort((a, b) =>
              a.inspectionName > b.inspectionName ? 1 : -1
            );
            custChecks.sort((a, b) => (a.letter > b.letter ? 1 : -1));

            sample.values = custChecks.concat(defChecks);

            this.checkValues.push(sample);
          }

          for (let s = 0; s < this.DHRIpc.length; s++) {
            let sample = this.DHRIpc[s];
            let defChecks = [];
            let custChecks = [];

            for (let v = 0; v < sample.values.length; v++) {
              if (sample.values[v].letter == "bool") {
                defChecks.push(sample.values[v]);
              } else {
                custChecks.push(sample.values[v]);
              }
            }

            defChecks.sort((a, b) => (a.IPCName > b.IPCName ? 1 : -1));
            custChecks.sort((a, b) => (a.letter > b.letter ? 1 : -1));

            sample.values = custChecks.concat(defChecks);
            this.checkValuesIPC.push(sample);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch((err) => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });
    },
    currentPage(page) {
      this.pagina = page; // someValue
    },
    gotRefresh(val) {
      this.pagina = 1;
      this.amount = 0;
      this.getData();
    },
    showStepDetails(step) {
      let detailIndex = this.DHRFlowSteps.findIndex(
        (x) => x.stepID == step.id && x.order == step.order
      );
      let completionIndex = this.DHRStepCompletion.findIndex(
        (x) => x.stepID == step.id
      );
      let deviationIndex = this.DHRStepDeviation.findIndex(
        (x) => x.stepID == step.id
      );

      let filteredValues = this.DHRStepValues.filter(
        (x) => x.stepID == step.id
      ).map((x) => x);

      this.selectedStepData = {
        stepDetails: this.DHRFlowSteps[detailIndex],
        stepDeviations: this.DHRStepDeviation[deviationIndex],
        stepCompletion: this.DHRStepCompletion[completionIndex],
        stepValues: filteredValues,
      };
    },
    showInspectionDetails(inspection) {
      let filteredValues = this.DHRInspectionValues.filter(
        (x) => x.stepID == step.id
      ).map((x) => x);

      this.selectedInspectionData = {
        inspectionDetails: this.DHRInspection,
        inspectionValues: filteredValues,
      };
    },
    showIpcDetails(ipc) {
      let filteredValues = this.DHRIpcValues.filter(
        (x) => x.stepID == step.id
      ).map((x) => x);

      this.selectedIPCData = {
        ipcDetails: this.DHRIpc,
        ipcValues: filteredValues,
      };
    },
  },
  watch: {
    pagina: function (val) {
      switch (val) {
        case 1:
          this.pageTitle = "General info (Device: " + this.deviceRef + ")";
          break;
        case 2:
          this.pageTitle = "Assembly details (Device: " + this.deviceRef + ")";
          break;
        case 3:
          this.pageTitle =
            "Production details (Device: " + this.deviceRef + ")";
          break;
        case 4:
          this.pageTitle = "Final inspection (Device: " + this.deviceRef + ")";
          break;
        case 5:
          this.pageTitle = "In Process Control (DHR: " + this.deviceRef + ")";
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
